import logger from "../logger";
var broadcastToDocument = function(name, params) {
    if (typeof window === "undefined") {
        return;
    }
    if (!name || typeof name !== "string") {
        logger.warn("broadcastToDocument requires a name of type string");
        return;
    }
    try {
        logger.log(name);
        document.dispatchEvent(new CustomEvent(name, params));
    } catch (error) {
        logger.warn("Failed to broadcast event " + name);
    }
};
export { broadcastToDocument };

//# sourceMappingURL=events.js.map